// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3rtfA","image":"Header_image__1OsQD","name":"Header_name__2dgZj","info":"Header_info__1itEh","infoRow":"Header_infoRow__1ZCWH"};